import { Select } from '../../Select'

export const OptGroup = Select.OptGroup
